export const initial = {
    lang:"et",
    session:null,
    ui_texts:{},
    decision:null,
}